import React from "react";
import { MetricListPanel, Panel, SectionGrid, SummaryGrid } from "../AdminAnalyticsCards";
import CssBarChart from "../charts/CssBarChart";
import AdminAnalyticsTable, { UserCell } from "../tables/AdminAnalyticsTable";
import { aa, formatDateTime, formatDay, formatNumber, getUserLabel, getUserSubLabel } from "../adminAnalyticsUtils";
function formatNewUsersSublabel(count) {
  return aa("new_users_sublabel", "{{count}} new", {
    count: formatNumber(count),
  });
}
export default function AdminAnalyticsUsersTab({
  data
}) {
  const summary = data?.summary || {};
  const profile = data?.profileCompletion || {};
  return <>
      <SummaryGrid cards={[{
      label: aa("total_users", "Total users"),
      value: formatNumber(summary.totalUsers)
    }, {
      label: aa("new_users", "New users"),
      value: formatNumber(summary.newUsers)
    }, {
      label: aa("active_users", "Active users"),
      value: formatNumber(summary.activeUsers)
    }, {
      label: aa("no_activity_users", "No activity users"),
      value: formatNumber(summary.usersWithNoActivity)
    }, {
      label: aa("pending_or_incomplete", "Pending or incomplete"),
      value: formatNumber(summary.pendingOrIncompleteProfiles)
    }, {
      label: aa("missing_avatar", "Missing avatar"),
      value: formatNumber(summary.usersMissingAvatar)
    }, {
      label: aa("favorite_species_set", "Favorite species set"),
      value: formatNumber(summary.usersWithFavoriteSpecies)
    }, {
      label: aa("methods_set", "Methods set"),
      value: formatNumber(summary.usersWithMethods)
    }]} />


      <SectionGrid>
        <CssBarChart title={aa("registrations_by_day", "Registrations by day")} rows={data?.registrationsByDay} getLabel={row => formatDay(row?.day)} getValue={row => row?.users} />

        <CssBarChart title={aa("users_by_country_and_city", "Users by country and city")} rows={data?.usersByCountryCity} getLabel={row => `${row?.country || aa("unknown", "Unknown")} / ${row?.city || aa("unknown", "Unknown")}`} getValue={row => row?.users} getSublabel={row => formatNewUsersSublabel(row?.newUsers)} />

        <Panel title={aa("profile_completion", "Profile completion")}>
          <div className="admin-analytics-completion-grid">
            {[[aa("missing_avatar", "Missing avatar"), profile.missingAvatar], [aa("missing_methods", "Missing methods"), profile.missingMethods], [aa("missing_favorite_species", "Missing favorite species"), profile.missingFavoriteSpecies], [aa("pending_or_incomplete", "Pending or incomplete"), profile.pendingOrIncomplete]].map(([label, value]) => <div className="admin-analytics-completion-item" key={label}>
                <span>{label}</span>
                <strong>{formatNumber(value)}</strong>
              </div>)}
          </div>
        </Panel>
        <MetricListPanel title={aa("location_distribution", "Location distribution")} rows={data?.usersByCountryCity} keyName="city" valueName="users" />

        <AdminAnalyticsTable title={aa("top_engaged_users", "Top engaged users")} rows={data?.topEngagedUsers} rowKey={row => getUserSubLabel(row)} columns={[{
        header: aa("user", "User"),
        render: row => <UserCell title={getUserLabel(row)} subtitle={getUserSubLabel(row)} />
      }, {
        header: aa("events", "Events"),
        render: row => formatNumber(row?.eventCount)
      }, {
        header: aa("sessions", "Sessions"),
        render: row => formatNumber(row?.sessionCount)
      }, {
        header: aa("posts", "Posts"),
        render: row => formatNumber(row?.postCount)
      }, {
        header: aa("last_seen", "Last seen"),
        render: row => formatDateTime(row?.lastSeenAt)
      }]} />

        <AdminAnalyticsTable title={aa("users_with_no_activity", "Users with no activity")} rows={data?.usersWithNoActivity} rowKey={row => getUserSubLabel(row)} className="admin-analytics-table-panel--wide" columns={[{
        header: aa("user", "User"),
        render: row => <UserCell title={getUserLabel(row)} subtitle={getUserSubLabel(row)} />
      }, {
        header: aa("created", "Created"),
        render: row => formatDateTime(row?.createdAt)
      }, {
        header: aa("profile_status", "Profile status"),
        render: row => row?.profileStatus || aa("unknown_2", "unknown")
      }, {
        header: aa("country", "Country"),
        render: row => row?.country || aa("unknown", "Unknown")
      }, {
        header: aa("city", "City"),
        render: row => row?.city || aa("unknown", "Unknown")
      }]} />

      </SectionGrid>
    </>;
}
